import { render, staticRenderFns } from "./slider-joint.vue?vue&type=template&id=36f81486&scoped=true&"
import script from "./slider-joint.js?vue&type=script&lang=js&"
export * from "./slider-joint.js?vue&type=script&lang=js&"
import style0 from "./slider-joint.vue?vue&type=style&index=0&id=36f81486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f81486",
  null
  
)

export default component.exports